import { ReactNode } from 'react'

interface HeadingProps {
  children: ReactNode
  className?: string
}

export const Heading1 = ({ children, className = '' }: HeadingProps) => (
  <h1 className={`text-3xl md:text-4xl font-bold ${className}`}>{children}</h1>
)

export const Heading2 = ({ children, className = '' }: HeadingProps) => (
  <h2 className={`text-2xl md:text-3xl font-semibold ${className}`}>
    {children}
  </h2>
)

export const Heading3 = ({ children, className = '' }: HeadingProps) => (
  <h3 className={`text-xl md:text-2xl font-semibold ${className}`}>
    {children}
  </h3>
)

export const Heading4 = ({ children, className = '' }: HeadingProps) => (
  <h4 className={`text-lg md:text-xl font-medium ${className}`}>{children}</h4>
)

export const Heading5 = ({ children, className = '' }: HeadingProps) => (
  <h5 className={`text-base md:text-lg font-medium ${className}`}>
    {children}
  </h5>
)

export const Heading6 = ({ children, className = '' }: HeadingProps) => (
  <h6 className={`text-sm md:text-base font-medium ${className}`}>
    {children}
  </h6>
)
